import type {SuperAgentRequest} from "superagent";
import request from "../../../util/SuperagentUtils";
import {Account} from "../../../types/Account";

export const getAllPartnerSubscriptions = (account: Pick<Account, 'id'>): SuperAgentRequest => {
  return request.get(`api/partner-subscription?accountId=${account.id}`);
}
